module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-forwarded-e968ad4daf77b46419a0afd194bae823.svg";